module.exports = __webpack_public_path__ + "static/media/sf_600_gray.ea4f0795ba2361177ea1cb6ef13379c3.png";